import { render, staticRenderFns } from "./InstallerDashboardSetUpTearDownData.vue?vue&type=template&id=5ca655de&scoped=true&"
import script from "./InstallerDashboardSetUpTearDownData.vue?vue&type=script&lang=js&"
export * from "./InstallerDashboardSetUpTearDownData.vue?vue&type=script&lang=js&"
import style0 from "./InstallerDashboardSetUpTearDownData.vue?vue&type=style&index=0&id=5ca655de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca655de",
  null
  
)

export default component.exports